






import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '../pbi-dict-workspace-id';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import { ClientEnum } from '@/enums/client.enum';
import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';

@Component({
  name: 'PbiNetworkSimulatorAfterSalesPage',
  components: { ReportPowerBiContainer }
})

export default class PbiNetworkSimulatorAfterSalesPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.DPaschoal, CountryEnum.Brasil], { brand: 'DPaschoal', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '8a5159fe-a2c0-4293-81e8-e0c84fa61568' });
  
    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Network Simulator After Sales Report`);
  }
} 

